import {overrideOrbitControls} from "./potree/naviagation/overrideOrbitControls";


export function postViewerOverride(viewer) {
    overrideOrbitControls(viewer)
}